import React, { Suspense, useMemo } from "react";
import { Form, Col } from "react-bootstrap";
import { Await, useAsyncValue, useRouteLoaderData } from "react-router-dom";
import { findRadioDayparts, formatDaypartText } from "../HelperFunctions";
import { useEffect } from "react";

export default function MusicTestDaypartPicker({ formData, setFormData, name, disabled, filterFunction = () => true }) {
    const { musicTestDayparts } = useRouteLoaderData("root");

    return (
        <Suspense fallback={<Fallback name={name} />}>
            <Await resolve={musicTestDayparts}>
                <Form.Group controlId={`${name}-music-test-daypart`} as={Col} className="col-12 col-xl-2 min-w-220">
                    <Form.Label>Daypart</Form.Label>
                    <DaypartSelect />
                </Form.Group>
            </Await>
        </Suspense>
    );

    function DaypartSelect() {
        const dayparts = useAsyncValue();
        const filteredDayparts = useMemo(() => {
            if (dayparts && formData.station[0] && formData.demo[0]?.data_type) {
                return findRadioDayparts(dayparts.data, formData.station[0].radio_id, formData.demo[0].data_type)
                    .filter(filterFunction)
                    .filter(x => (formData.demo[0].listener_group === 0 ? true : x.daypart_id === 1))
                    .sort((a, b) => a.daypart_id - b.daypart_id);
            }
        }, [dayparts]);

        // If only main daypart is available, pick it
        useEffect(() => {
            if (filteredDayparts?.length === 1 && formData.daypartId !== 1) {
                setFormData({ ...formData, daypartId: 1 });
            }
        }, [filteredDayparts?.length]);

        return (
            <Form.Select
                value={(formData.station || formData.station.length) && formData.demo.length ? formData.daypartId : "placeholder"}
                onChange={e => setFormData({ ...formData, daypartId: Number(e.target.value) })}
                disabled={disabled || !formData.demo.length || (!formData.station && !formData.station.length)}>
                <option value={"placeholder"} disabled>
                    {formData.demo.length ? "Select daypart..." : "Select demo first..."}
                </option>
                {filteredDayparts?.map(x => (
                    <option key={x.daypart_id} value={x.daypart_id}>
                        {formatDaypartText(x)}
                    </option>
                ))}
            </Form.Select>
        );
    }
}

function Fallback({ name }) {
    return (
        <Form.Group controlId={`${name}-music-test-daypart-fallback`} as={Col} className="col-12 col-xl-2 min-w-220">
            <Form.Label>Daypart</Form.Label>
            <Form.Select value={"placeholder"} disabled>
                <option value={"placeholder"}>Loading dayparts...</option>
            </Form.Select>
        </Form.Group>
    );
}
